export const HEAT_COLORS = ['#2ecc71', '#f1c40f', '#e67e22', '#e74c3c', '#c0392b'];

export function getHeatColor(count, maxCount) {
  if (maxCount <= 0) return HEAT_COLORS[0];
  const ratio = count / maxCount;
  const index = Math.min(HEAT_COLORS.length - 1, Math.floor(ratio * HEAT_COLORS.length));
  return HEAT_COLORS[index];
}
